function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.97 17.988h-1.962a1 1 0 00-1 1h-.026V26a1.002 1.002 0 01-2.001 0v-6.818c.013-.065.039-.125.039-.194a1 1 0 00-1-1h-2.03a3.008 3.008 0 01-3.003-3.005v-1.014l13.987.034v.98a3.008 3.008 0 01-3.004 3.005M22.474 3.98H14.02a1 1 0 00-1 .99l-.04 4.019a1 1 0 00.99 1.01h.01a1 1 0 001-.99l.03-3.03h7.464c.27 0 .5.23.5.5v5.523l-13.987-.034V6.48c0-.271.228-.5.5-.5h.554a1 1 0 100-2h-.554a2.503 2.503 0 00-2.5 2.5v8.502a5.01 5.01 0 005.004 5.005h.99V26c0 1.655 1.346 3 3 3 1.655 0 3-1.345 3-3v-6.012h.989a5.01 5.01 0 005.004-5.005V6.48c0-1.378-1.121-2.5-2.5-2.5",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcMapLayers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcMapLayers;